@if (status() !== 'label_active') {
  <div class="flex align-items-center" [style.color]="color()">
    <span
      [attr.title]="'global.status.' + status() | translate"
      class="hidden md:block"
    >
      {{ 'global.status.' + status() | translate }}
    </span>
    <faq-status-icon [status]="status()" />
  </div>
}
